export default __webpack_public_path__ + "static/banner-understanding-your-credit-score-a7daa222627dfd0bb79ec12f56a9c830.jpg";